module.exports = __webpack_public_path__ + "static/media/7.97f0b4ec.jpg";